import Dialog from 'components/Dialog';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import * as yup from 'common/yup';
import Panel from 'components/Panel';
import {Grid, Typography} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import FormikTransferTree from 'components/inputs/FormikTransferTree';
import {useSelector} from 'react-redux';
import {layoutSelectors} from 'features/layout/redux';
import {DiplomatObject, IDiplomatObject} from 'types/DiplomatObject';
import FormikTextField from 'components/inputs/FormikTextField';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {useFieldValueGetter} from 'components/hook-form/useFieldValueGetter';
import {useFilteredTransactions} from 'common/hooks/useFilteredTransactions';

const BackupSelectionFormType = yup.object({
   transactionNames: yup.array().of(DiplomatObject),
   filter: yup.string(),
});
export type IBackupSelectionFormType = yup.InferType<typeof BackupSelectionFormType>;

type Props = {
   onClose: (
      transactionNames?: IBackupSelectionFormType,
      helpers?: FormOnSubmitHelpers<IBackupSelectionFormType>
   ) => void;
};
const BackupSelectionDialog = memo(({onClose}: Props) => {
   const {t} = useTranslation();

   // const handleSubmit = React.useCallback((values: IBackupSelectionFormType, helpers: FormikHelpers<IBackupSelectionFormType>) => {
   //     onClose(values.transactionNames, helpers);
   // }, [onClose]);

   return (
      <Dialog
         maxWidth={'md'}
         open={true}
         close={onClose}
         header={t('Select Transactions To Backup')}
      >
         <Formik initialValues={BackupSelectionFormType.cast({})} onSubmit={onClose}>
            <BackupSelectionForm onClose={onClose} />
         </Formik>
      </Dialog>
   );
});

function BackupSelectionForm({onClose}: Props) {
   const {t} = useTranslation();
   const folders = useSelector(layoutSelectors.transactionSyncFoldersSelector);

   const getValue = useFieldValueGetter<IBackupSelectionFormType>();
   const filter = getValue('filter');
   const filtered = useFilteredTransactions(filter);

   return (
      <>
         <Typography>
            {t(
               'Select transactions to create a merge file containing the transactions and their related partners and keys.'
            )}
         </Typography>
         <FormikTransferTree
            name="transactionNames"
            options={filtered}
            folders={folders}
            leftLabel={t('Available Transactions')}
            rightLabel={t('Selected Transactions')}
         />
         <Grid container justifyContent="center">
            <Grid item md={6} sm={8}>
               <Panel name={t('Filter Criteria')}>
                  <Typography>
                     {t(
                        'Enter a phrase to display only Transaction names containing the filter phrase in the Available Transactions panel.'
                     )}
                  </Typography>
                  <Grid container spacing={2} justifyContent="center">
                     <Grid item xs={10}>
                        <FormikTextField autoFocus name="filter" label={t('Filter Phrase')} />
                     </Grid>
                     {/* <Grid item><Button>{t('')}</Button></Grid>
                     <Grid item><Button>{t('')}</Button></Grid> */}
                  </Grid>
               </Panel>
            </Grid>
         </Grid>
         <FormFooterButtons cancel={onClose} />
      </>
   );
}

export default BackupSelectionDialog;
